// extracted by mini-css-extract-plugin
export default {"week":"WeekPayment_week__5f2-+","title":"WeekPayment_title__E9Xhe","row":"WeekPayment_row__Y1mrv","table":"WeekPayment_table__nmLIX","employee":"WeekPayment_employee__53Vye"};